import styled from "styled-components";

export const Div = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;

export const Input = styled.input`
  display: block;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  border: 1px solid black;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
`;

export const Number = styled.input`
  display: block;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  border: 1px solid black;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
`;

export const Label = styled.label`
  line-height: 2;
  text-align: left;
  display: block;
  margin-bottom: 13px;
  margin-top: 20px;
  color: black;
  font-size: 14px;
  font-weight: 200;
`;

export const Textarea = styled.textarea`
  line-height: 2;
  text-align: left;
  display: block;
  margin-bottom: 13px;
  margin-top: 20px;
  color: black;
  font-size: 14px;
  font-weight: 200;
  width: 100%;
  height: 180px;
`;

export const Select = styled.select`
  display: block;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  border: 1px solid black;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
`;

export const ButtonAction = styled.button`
  background-color: black;
  color: white;
  font-size: 20px;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 10px 10px;
  cursor: pointer;
  float: right;
`;

export const ButtonSupprimer = styled.button`
  background-color: red;
  color: white;
  font-size: 20px;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 10px 10px;
  border: none;
  cursor: pointer;
  float: left;
`;

export const ButtonAnnuler = styled.button`
  background-color: grey;
  color: white;
  border: none;
  font-size: 20px;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 10px 10px;
  cursor: pointer;
  float: left;
`;

export const Iupload = styled.input`
  display: block;
  background-color: #122630;
  color: white;
  border: none;
  font-size: 20px;
  border-radius: 5px;
  margin: 10px 10px;
  cursor: pointer;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
`;
export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 26px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;
export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px;
  height: 26px;
  &:checked + ${CheckBoxLabel} {
    background: #4fbe79;
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 21px;
      transition: 0.2s;
    }
  }
`;

export const RowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
`;

export const ButtonWithSelect = styled.button`
  background-color: lightGrey;
  color: white;
  border-radius: 5px;
  border: none;
  margin-right: 2px;
  margin-top: 20px;
  cursor: pointer;
  height: 20px;
`;
